import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FormControl, Validators} from '@angular/forms';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {AuthenticationService} from '../../auth/_services';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from 'app/service/usuario/usuario.service';
import { UsuarioPerfilDTO } from 'app/model/usuarioPerfil.dto';
import { FraseSecretaRequest } from 'app/model/fraseSecretaRequest.dto';
import { IdentityStorage } from 'app/auth/_models/identity.storage';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.sass']
})
export class LoginComponent implements OnInit {
    loginText = new FormControl('', [Validators.required]);
    senha = new FormControl('', [Validators.required]);
    fraseSecreta = new FormControl('', [Validators.required, Validators.minLength(10)]);
    confirmacaoFrase = new FormControl('', []);
    mostrarFraseSecreta = false;
    usuarioPerfilDto = new UsuarioPerfilDTO();
    @BlockUI() blockUI: NgBlockUI;

    loading = false;
    submitted = false;
    returnUrl: string;
    error = '';

    constructor(
        public router: Router,
        private toasterService: ToastrService,
        private authenticationService: AuthenticationService,
        private usuarioService: UsuarioService,
        public identityStorage: IdentityStorage,
    ) {

    }

    ngOnInit() {
        this.authenticationService.clearAuthentication();
    }

   login() {
        if (this.validarCampos()) {
            var login = this.loginText.value;
            var senha = this.senha.value;
            if (login == null || login == '' || senha == null || senha == '') {
                this.toasterService.warning('Matrícula e Senha são obrigatórias');
                return;
            }
            this.blockUI.start('Aguarde!');
            const numbers = /^[0-9]+$/;
            if (this.loginText.value.match(numbers)) {
                this.etapaLoginSenha();
            }
                this.blockUI.stop();
        }
    }

    validarCampos(): boolean {
        var retorno = true;
        if (this.loginText.value == null || this.loginText.value == '') {
            this.loginText.setErrors(['']);
            retorno = false;
        }
        if (this.senha.value == null || this.senha.value == '') {
            this.senha.setErrors(['']);
            retorno = false;
        }

        return retorno;
    }

    private etapaLoginSenha() {
      this.authenticationService.authenticate(this.loginText.value, this.senha.value)
        .subscribe(
          result => {
            if (result.ok) {
              this.blockUI.stop();
              this.mostrarFraseSecreta = true;
            }
            //   this.error = result.errorMessage;
            // else if (result.ok === false) {
            //     this.blockUI.stop();
            //     this.toasterService.warning('Matrícula bloqueada!')
            // }
        },
          error => {
            this.error = error;
            this.loading = false;
            this.toasterService.warning('A senha está incorreta!');
            this.blockUI.stop();
          }
        );
    }

    fraseRedirecionar(){

        var fraseSecreta = this.fraseSecreta.value;
        if (fraseSecreta == null || fraseSecreta == '') {
            this.toasterService.warning('A frase secreta é obrigatória');
            return;

        }
        this.usuarioPerfilDto.FraseSecretaRequest = new FraseSecretaRequest;
        this.usuarioPerfilDto.FraseSecretaRequest.fraseSecreta = this.fraseSecreta.value;
        this.usuarioPerfilDto.FraseSecretaRequest.confirmacaoFrase = this.confirmacaoFrase.value;
        this.usuarioService.verificarFraseSecreta(this.usuarioPerfilDto.FraseSecretaRequest)
            .subscribe(
                result => {
                    this.authenticationService.saveAuthData();
                    this.router.navigate(['home']);
                },
                error => {
                        this.error = error;
                        this.loading = false;
                        this.toasterService.warning('A frase secreta está incorreta!');
                        this.blockUI.stop();

                });
    }

    ngOnDestroy() {
        return this.authenticationService.isAuthenticated();
      }

    voltar(){
        this.mostrarFraseSecreta = false;
        this.identityStorage.clearAuthData();
        localStorage.removeItem('currentUser');
    }

}
